import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { Button, Typography, Grid } from '@material-ui/core';
import { Block, Edit, Close, Save, HourglassEmpty } from '@material-ui/icons';
import parse from 'html-react-parser';
import SekilasTentangKami from './SekilasTentangKami';
import { getPageName, updateContent } from '../../../services';
import { Editor, ScrollTab, Loading, TabDewan } from '../../../components';
import GrupKami from './GroupKami';
// import { PenghargaanDashboard } from './Penghargaan';
import { CrudContent } from '../../../components';

const initContent = {
  id: '',
  titleId: '',
  titleEn: '',
  contentId: '',
  contentEn: '',
  image: '',
  oldImage: '',
  imageRead: '',
};

const TentangKamiSub = ({ query }: { query: string }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loadingState, setLoadingState] = useState(true);
  const [loadingButtonState, setLoadingButtonState] = useState(false);
  const [openEditor, setOpenEditor] = useState(false);
  const [contentState, setContentState] = useState<any>(initContent);

  const {
    id,
    titleId,
    titleEn,
    contentId,
    contentEn,
    image,
    imageRead,
    oldImage,
  } = contentState;

  const getData = async () => {
    try {
      const res = await getPageName(query);
      if (res.status === 'error') {
        enqueueSnackbar(res.message, {
          variant: 'error',
        });
        setLoadingState(false);
        return;
      }
      const { id, title_id, title_en, content_id, content_en, image } =
        res.data;
      setContentState({
        ...contentState,
        id,
        titleId: title_id,
        titleEn: title_en,
        contentId: content_id,
        contentEn: content_en,
        image: image,
        oldImage: image,
      });
      setLoadingState(false);
    } catch (err: any) {
      enqueueSnackbar(err.message, {
        variant: 'error',
      });
    }
  };

  const updateData = async () => {
    try {
      setLoadingButtonState(true);
      const body = new FormData();
      body.append('title_id', titleId);
      body.append('title_en', titleEn);
      body.append('content_id', contentId);
      body.append('content_en', contentEn);
      body.append('image', image);
      body.append('old_image', oldImage);
      const res = await updateContent(id, body);
      setLoadingButtonState(false);
      if (res.status === 'error') {
        enqueueSnackbar(res.message, {
          variant: 'error',
        });
        return;
      }
      setContentState(initContent);
      setOpenEditor(false);
      enqueueSnackbar(`${titleId} Berhasil di update`, {
        variant: 'success',
      });
    } catch (err: any) {
      setLoadingButtonState(false);
      enqueueSnackbar(err.message, {
        variant: 'error',
      });
    }
  };

  const handleImageChange = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      setContentState({
        ...contentState,
        oldImage: image,
        image: event.target.files[0],
        imageRead: URL.createObjectURL(event.target.files[0]),
      });
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, openEditor]);

  return (
    <>
      {loadingState ? (
        <Loading />
      ) : (
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '2rem',
            }}
          >
            <Typography color='primary' variant='h4'>
              {titleId}
            </Typography>
            {openEditor ? (
              <div>
                <Button
                  variant='outlined'
                  style={{ marginRight: 16 }}
                  size='large'
                  startIcon={<Close />}
                  onClick={() => {
                    setOpenEditor(false);
                    setContentState(initContent);
                  }}
                  disabled={loadingButtonState}
                >
                  Cancel
                </Button>
                <Button
                  variant='outlined'
                  color='primary'
                  size='large'
                  startIcon={loadingButtonState ? <HourglassEmpty /> : <Save />}
                  onClick={updateData}
                  disabled={loadingButtonState}
                >
                  {loadingButtonState ? 'Loading' : 'Save'}
                </Button>
              </div>
            ) : (
              <Button
                variant='contained'
                color='primary'
                size='large'
                startIcon={<Edit />}
                onClick={() => setOpenEditor(true)}
                disabled={openEditor}
                style={{ marginLeft: '1rem' }}
              >
                Edit
              </Button>
            )}
          </div>
          {query === 'sejarah-perusahaan' &&
            (openEditor ? (
              <div style={{ marginBottom: '2rem' }}>
                <Button variant='outlined' color='primary' component='label'>
                  Upload Image
                  <input type='file' onChange={handleImageChange} hidden />
                </Button>
                <Typography
                  color='textPrimary'
                  style={{ marginBottom: '0.5rem' }}
                >
                  * Max size 5mb
                </Typography>
                {imageRead || image ? (
                  <img
                    style={{ height: '200px' }}
                    src={
                      imageRead ||
                      `${process.env.REACT_APP_URL}/images/${image}`
                    }
                    alt='Not Found!'
                  ></img>
                ) : (
                  <div
                    style={{
                      textAlign: 'center',
                      backgroundColor: '#ededed',
                      padding: '1rem',
                      borderRadius: '4px',
                      width: '200px',
                    }}
                  >
                    <Block />
                    <Typography color='textSecondary'>
                      Photo does not exist
                    </Typography>
                  </div>
                )}
              </div>
            ) : (
              <img
                style={{ height: '200px', marginBottom: '2rem' }}
                src={`${process.env.REACT_APP_URL}/images/${image}`}
                alt='sejarah-perusahaan'
              ></img>
            ))}

          {openEditor ? (
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Typography
                  color='primary'
                  variant='h6'
                  gutterBottom
                  style={{ marginBottom: '1rem' }}
                >
                  Bahasa Indonesia
                </Typography>
                <Editor
                  content={contentId}
                  onChange={(content: any) =>
                    setContentState({ ...contentState, contentId: content })
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  color='primary'
                  variant='h6'
                  gutterBottom
                  style={{ marginBottom: '1rem' }}
                >
                  English
                </Typography>
                <Editor
                  content={contentEn}
                  onChange={(content: any) =>
                    setContentState({ ...contentState, contentEn: content })
                  }
                />
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Typography
                  color='primary'
                  variant='h6'
                  gutterBottom
                  style={{ marginBottom: '1rem' }}
                >
                  Bahasa Indonesia
                </Typography>
                <div
                  style={{
                    padding: '1rem',
                    border: '1px solid rgb(241, 241, 241)',
                    borderRadius: 4,
                  }}
                  id='content'
                >
                  {parse(contentId)}
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  color='primary'
                  variant='h6'
                  gutterBottom
                  style={{ marginBottom: '1rem' }}
                >
                  English
                </Typography>
                <div
                  style={{
                    padding: '1rem',
                    border: '1px solid rgb(241, 241, 241)',
                    borderRadius: 4,
                  }}
                  id='content'
                >
                  {parse(contentEn)}
                </div>
              </Grid>
            </Grid>
          )}
        </>
      )}
    </>
  );
};

const data = [
  {
    tab: 'Sekilas Tentang Kami',
    tabPanel: <SekilasTentangKami />,
  },
  {
    tab: 'Sejarah Perusahaan',
    tabPanel: <TentangKamiSub query='sejarah-perusahaan' />,
  },
  {
    tab: 'Visi & Misi',
    tabPanel: (
      <div>
        <TentangKamiSub query='Visi' />
        <div style={{ height: '2rem' }} />
        <TentangKamiSub query='Misi' />
      </div>
    ),
  },
  {
    tab: 'Struktur Organisasi',
    tabPanel: <TabDewan />,
  },
  {
    tab: 'Grup Kami',
    tabPanel: <GrupKami />,
  },
  {
    tab: 'Penghargaan',
    tabPanel: <CrudContent title='Penghargaan' type={3} />,
  },
];

const TentangKami = () => {
  return <ScrollTab content={data} />;
};

export default TentangKami;
